import { useEffect, useRef } from 'react';

/**
 * Run `run` at most once — the first render where `enabled` is true. The latest `run` is kept in a
 * ref and the effect depends only on `enabled`, so an inline callback doesn't re-subscribe the
 * effect on every render; the one-shot latch also survives StrictMode's double-invoke. Replaces the
 * hand-rolled `hasRun = useRef(false)` guard.
 */
export function useRunOnceWhen(enabled: boolean, run: () => void): void {
  const hasRunRef = useRef(false);
  const runRef = useRef(run);
  useEffect(() => {
    runRef.current = run;
  });

  useEffect(() => {
    if (enabled && !hasRunRef.current) {
      hasRunRef.current = true;
      runRef.current();
    }
  }, [enabled]);
}
